import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(advancedFormat)
export default function dateView(value) {
  return dayjs(value).format('dddd, MMMM Do')
}
